import { useTranslations } from '@npco/common-utils-translations'
import {
  Flex,
  NumberBadge,
  NumberBadgeVariant,
  Toggle,
} from '@npco/zeller-design-system'
import { useGoToCCOutstandingExpenseComingSoon } from 'features/CCOutstandingExpenseComingSoon/cc-outstanding-expense-coming-soon-routing'
import { useFeatureFlags } from 'features/FeatureFlags'

import { useIsMobileResolution } from 'hooks/useIsMobileResolution'

import { useGetOutstandingExpensesFilter } from '../hooks/useGetOutstandingExpensesFilter/useGetOutstandingExpensesFilter'
import { useToggleOutstandingExpensesFilter } from '../hooks/useToggleOutstandingExpensesFilter/useToggleOutstandingExpensesFilter'
import { outstandingExpensesToggleTranslations } from './OutstandingExpensesToggle.i18n'

export const OutstandingExpensesToggle = () => {
  const t = useTranslations(outstandingExpensesToggleTranslations)
  const { goToCCOutstandingExpenseComingSoon } =
    useGoToCCOutstandingExpenseComingSoon()

  const { isOutstandingExpensesFilterOn } = useGetOutstandingExpensesFilter()
  const { toggleFilter } = useToggleOutstandingExpensesFilter()

  const isMobile = useIsMobileResolution()
  const flags = useFeatureFlags()

  return (
    <Flex
      gap="10px"
      position="absolute"
      zIndex="10"
      right="0"
      top="0"
      onClick={() => {
        if (!flags.CorpCardsOutstandingTransactionsFilter) {
          goToCCOutstandingExpenseComingSoon({ stage: 'coming-soon-modal' })
        }
      }}
    >
      <NumberBadge
        variant={NumberBadgeVariant.Default}
        text={isMobile ? t('badgeTextMobile') : t('badgeText')}
      />
      <Toggle
        checked={isOutstandingExpensesFilterOn}
        disabled={!flags.CorpCardsOutstandingTransactionsFilter}
        onChange={toggleFilter}
      />
    </Flex>
  )
}
